<p class="leading-6 whitespace-pre-line">{{ message.text }}</p>
